import { CircleCheck } from 'lucide-react';

import { EmptyCardSection } from '@/components/empty-states/empty-card-section';
import { NO_FAULTED_EQUIPMENT } from '@/features/equipment-browser/faulted-devices/faulted-devices.constants';

/**
 * Shown once nothing is faulted, including right after the last reset. Matches the
 * Faulted tab's empty state, so an emptied table reads as every fault cleared.
 */
export const EmptyResetFaultedTable = () => (
  <EmptyCardSection
    dataComponent="EmptyResetFaultedTable"
    dataTestId="empty-reset-faulted-table"
    icon={CircleCheck}
    message={NO_FAULTED_EQUIPMENT.message}
    subtext={NO_FAULTED_EQUIPMENT.subtext}
  />
);
